<template>
  <div>
     <v-btn @click="goBack" width="20px" text><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
    <h2 class="headerPosition">Customization</h2>
    <p class="headerPosition">Design your Tippings page</p>
    <v-alert
      v-model="alert"
      type="error"
      style="text-align:start;margin:10px auto 10px auto"
      width="400px"
    >
      {{ message }}
    </v-alert>
    <v-form>
       <p style="margin:25px auto auto auto;width:400px;text-align:start">
        Username
      </p>
      <v-text-field
        type="username"
        color="#e50914"
        @keyup="slugName()"
        outlined
        label="yourusername"
        v-model="username"
        :rules="[rules.required, rules.username]"
        style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
        prefix="https://tippings.me/"
        single-line
        :readonly="readonly"
        :hint="'Your username is '+ username"
      />
  

      <p style="margin:25px auto auto auto;width:400px;text-align:start">
        Choose Theme color
      </p>
      <v-text-field
        v-model="btncolor"
        v-mask="mask"
        hide-details
        solo
        style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
      >
        <template v-slot:append>
          <v-menu
            v-model="menuBtn"
            top
            nudge-bottom="105"
            nudge-left="16"
            :close-on-content-click="false"
            style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
          >
            <template v-slot:activator="{ on }">
              <div :style="btnStyle" v-on="on" />
            </template>
            <v-card>
              <v-card-text class="pa-0">
                <v-color-picker v-model="btncolor" :value="btncolor" flat />
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
      </v-text-field>
      <p style="margin:22px auto auto auto;width:400px;text-align:start">
        Choose Background color
      </p>
      <v-text-field
        v-model="bgcolor"
        v-mask="mask"
        hide-details
        solo
        style="text-align:start;margin:auto;border-radius:10px;width:400px;height:60px"
      >
        <template v-slot:append>
          <v-menu
            v-model="menuBg"
            top
            nudge-bottom="105"
            nudge-left="16"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <div :style="bgStyle" v-on="on" />
            </template>
            <v-card>
              <v-card-text class="pa-0">
                <v-color-picker v-model="bgcolor" :value="bgcolor" flat />
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
      </v-text-field>
      <p
        v-if="username != ''"
        style="margin-top:90px;text-align:start;margin:auto;width:400px;font-size:12px"
      >
        For existing Tell! users, read
        <a
          style="color:#e50914"
          href="https://tell.africa/admin/introducing-tippings/"
          >this guide</a
        >
        to learn how to link<br />
        your Tell! Account to your Tippings account
      </p>
    </v-form>
    <div class="text-center">
    <v-btn
      x-large
      width="286px"
      class="mt-10 white--text"
      rounded
      color="#e50914"
      @click="submit()"
      :loading="loading"
    >
      Submit
      <v-icon color="white" class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
    </div>
  </div>
</template>


<script>
import slugify from "slugify"

export default {
  data() {
    return {
      alert: false,
      username: "",
      types: ["hex"],
      type: "hex",
      hex: "#FFFFFF",
      hexa: "#FFFFFF",
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },
      hover: false,
      mask: "!#XXXXXXXX",
      menu: false,
      menuBg: false,
      menuBtn: false,
      btncolor: "#e50914",
      bgColor: "",
      message: "",
      bgcolor: "#FFFFFF",
      readonly:false,
      slug:"",
      rules: {
        required: (value) => !!value || "Required.",
        username: (value) => {
          const pattern = /^[a-z][a-z-]*[a-z]$/;
          return (
            pattern.test(value) ||
            "Your username should not have space and should be in small letters"
          );
        },
      },
    };
  },

  props: {
    loading: {
      type: Boolean,
    },
  },

  computed: {
    showColor() {
      if (typeof this.color === "string") return this.color;
      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    bgStyle() {
      const { bgcolor, menuBg } = this;
      return {
        backgroundColor: bgcolor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menuBg ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    btnStyle() {
      const { btncolor, menuBtn } = this;
      return {
        backgroundColor: btncolor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menuBtn ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },

  created(){
    if(localStorage.getItem('username') != null){
     this.username = localStorage.getItem('username')
     this.readonly = true
    }
  },

  methods: {
    goBack(){
     this.$emit('goBack')
    },

    slugName(){
        this.username= slugify(this.username, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@]/g,
            lower: true,
          })
    },
    submit() {
      if (this.username == "") {
        this.$swal({
          title: "Hollup Hollup!",
          text: "You need to enter your username",
          icon: "error",
          confirmButtonText: "Cool",
        });
      } else {
         let payLoad = {
          color: this.btncolor,
          bg: this.bgcolor,
          username: this.username
        }
        this.$emit("submit", payLoad);
      }
    },
  },
};
</script>
